import { Col, Row } from "antd";
import React from "react";
import Lottie from "lottie-react";
import styled from "styled-components";
import { MIN_MORNITOR_WIDTH } from "../../components/constants";
import { theme } from "../../theme";
import Check from "../../assets/icons/Check.json";

const AppConfirm: React.FC = () => {
  return (
    <Container>
      <NavWrapper>
        <NavTextWrapper>
          <NavText>제휴 신청완료</NavText>
        </NavTextWrapper>
      </NavWrapper>{" "}
      <Lottie animationData={Check} />
      <Row gutter={[0, 12]} style={{ width: "100%" }}>
        <Col span={24}>
          <ConfirmTitle>제휴 신청 완료</ConfirmTitle>
        </Col>
        <Col span={24}>
          <ConfirmBody>
            <Row>
              <Col span={24}>제휴 신청이 완료되었습니다.</Col>
              <Col span={24}>담당자가 승인 혹은 반려 안내 드릴 예정입니다.</Col>
            </Row>
          </ConfirmBody>
        </Col>
      </Row>
    </Container>
  );
};
export default AppConfirm;
const NavWrapper = styled.div`
  margin: 60px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    max-width: 100%;
    margin: 0px;
    min-height: 56px;
    justify-content: center;
    align-items: center;
    background-color: ${theme.colors.white};
  }
`;
const NavTextWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  max-width: 700px;

  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    max-width: none;
    min-width: none;
  }
`;
const ConfirmTitle = styled.div`
  ${theme.typo.heading.b24};
`;
const ConfirmBody = styled.div`
  ${theme.typo.body.r16};
  color: ${theme.colors.gray3};
`;

const NavText = styled.div`
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: 0em;
  text-align: left;
  cursor: pointer;
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    ${theme.typo.heading.b18};
    max-width: 100vw;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0em;
    height: 24px;

    text-align: center;
    color: ${theme.colors.gray1};
  }
`;
const Container = styled.div`
  display: flex;
  min-height: 100vh;
  max-height: 100vh;
  height: 100vh;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: auto;
  overflow-x: hidden;
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    height: 100vh;
    flex-direction: column;
    background: ${theme.colors.white};
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0px 20px;
  }
`;
